import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/fluent-light/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'
import 'element-plus/lib/theme-chalk/index.css'
// import {InlineSvgPlugin} from 'vue-inline-svg';
import InlineSvg from 'vue-inline-svg';
const app = createApp(App)
app.component('inline-svg', InlineSvg);
app.use(router).use(ElementPlus).use(PrimeVue).mount('#app')
